import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPagePorto = props => {
  return <CityLandingPage cityKey="Porto" cityConfig={cityContent.porto} {...props} />;
};

export default LandingPagePorto;
